import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of as observableOf } from 'rxjs';

@Injectable()
export class PreloadSelectedModules implements PreloadingStrategy {
  private preloadedModules: string[] = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data['preload'] && route.path) {
      // add the route path to our preloaded module array
      this.preloadedModules.push(route.path);
      return load();
    } else {
      return observableOf(null);
    }
  }
}
